import './masonry-layout'
import $ from 'jquery'
import { getUrlParameters } from './../main/vendors/get-url-parameters'

$(document).ready(function() {
	const $loadMore = $('#ccc-posts-loadmore')
	const $postsList = $('#ccc-posts-list')
	const $postsCat = $('#posts-cat')
	const $postsArea = $('#posts-area')
	const $postsSearchForm = $('#posts-search-form')
	const $postsSearchInput = $('#posts-search-input')
	const passedCat = getUrlParameters('category')
	const catList = {}

	let $grid
	if (!$postsList.length) {
		return
	}

	let safePassedCat = ''
	if (passedCat) {
		const label = $postsCat.find('option[value="' + passedCat + '"]').text()
		if (label) {
			safePassedCat = passedCat
			$('#posts-cat-wrapper .selectric .label').text(label)
		}
	}

	if (!$postsArea.length) {
		return
	}

	let postType = $postsArea.attr('data-post-type')
	postType = postType ? postType : 'post'

	const newsEndPoint = wp_data.home_url + '/wp-admin/admin-ajax.php'
	let waiting = true

	const args = {
		paged: 1,
		newscat: safePassedCat,
		keyword: '',
		postType: postType
	}
	//initialise

	const displayLoadMore = (show = false) => {
		$loadMore.toggleClass('show', show)
	}

	const wait = () => {
		waiting = true
		$postsArea.addClass('waiting')
	}

	const ready = () => {
		waiting = false
		$postsArea.removeClass('waiting')
	}

	const fetchPosts = (args = {}, fromStart = true) => {
		wait()
		const { paged, newscat, keyword, postType } = args
		$.get(newsEndPoint, {
			action: 'fw_get_posts',
			paged,
			newscat,
			keyword,
			postType
		}).then(
			response => {
				const { data, next } = JSON.parse(response)
				if (data) {
					renderPosts(data, fromStart, postType)
				}
				displayLoadMore(next)
				ready()
			},
			() => {
				$postsList.html('Oooops, something happend!')
			}
		)
	}
	fetchPosts(args)

	$postsSearchForm.on('submit', function(e) {
		e.preventDefault()
		if (waiting) {
			return
		}
		args.paged = 1
		args.keyword = $postsSearchInput.val()
		fetchPosts(args)
	})

	$postsCat.on('change', function(e) {
		if (waiting) {
			return
		}
		args.paged = 1
		args.newscat = $(this).val()
		fetchPosts(args)
	})

	$(document).on('click', '.news-article-entry .cat', function(e) {
		const newCat = $(this).attr('data-value')
		if (waiting || newCat === args.newscat) {
			return
		}
		args.paged = 1
		args.newscat = newCat
		fetchPosts(args)
		$('html,body').animate({ scrollTop: $('#news-list-filter').offset().top })
	})

	$loadMore.on('click', function(e) {
		e.preventDefault()
		if (waiting) {
			return
		}
		args.paged = args.paged + 1
		fetchPosts(args, false)
	})

	const renderPosts = (data = null, fromStart = true, postType = 'post') => {
		if (fromStart) {
			$postsList.html('')
			$grid = ''
		}
		if (data.length) {
			if (fromStart) {
				$postsList.prepend(
					'<div class="grid-sizer" style="width: calc(50% - 10px);"></div>'
				)

				$grid = $('.grid').masonry({
					gutter: 20,
					itemSelector: '.grid-item',
					columnWidth: '.grid-sizer',
					percentPosition: true
				})
			}
			renderNews(data, fromStart)
		} else {
			$postsList.append(
				'<div class="not-found-text"><div data-flex-fs>Sorry, but content not found.</div></div>'
			)
		}
	}
	const renderNews = (data = null, fromStart) => {
		let itemsString = ''
		data.forEach((item, index) => {
			const itemString = `<div class="grid-item news-article-entry">
					<a href="/?p=${item.id}#content-anchor">
						<h3 class="title">${item.title}</h3>
						<div class="date">${item.date}</div>
					</a>

					<div class="excerpt">${item.excerpt}</div>
					<div class="cats">
					${item.category_obj
						.map(function(a) {
							return `<div data-value="${a.slug}" class="cat">${a.name}</div>`
						})
						.join('')}
				</div>
				</div>`
			itemsString += itemString
		})
		const $items = $(itemsString)
		$grid.append($items).masonry('appended', $items)
	}
})
